<div class="container-fluid mx-0 px-0">
    <div class="bg-dark pt-sm-2 pt-md-2 pl-3">
        <a class="text-light" href="#">
            <img src="assets/img/mafuta-logo-2.svg" class="logo ml-2 mr-0 px-0" /><span class="h4">ThunderBoltApp</span></a>
    </div>
</div>


<router-outlet>
</router-outlet>
